import { useEffect, useState } from "react";
import { useItemsByList } from "./useItems";
import { useOrgData } from "./useOrgData";
import { useProjectsByList } from "./useProjects";
import _ from "lodash";
import { useSurveyData } from "./useSurveyData";
import { useOrgAdmins } from "./useOrgAdmins";

export const useListDashboardData = (listId: string) => {
  const { org, loading: orgsLoading } = useOrgData(listId);
  const { projects, loading: projectsLoading } = useProjectsByList(listId);
  const { itemsData, loading: itemsLoading } = useItemsByList(listId);
  const { surveyResults, loading: surveyLoading } = useSurveyData(listId);
  const { admins, loading: adminsLoading } = useOrgAdmins(listId);

  const [currLoading, setCurrLoading] = useState<boolean>(true);
  const [totalItems, setTotalItems] = useState<number>(0);
  const [logCount, setLogCount] = useState<number>(0);
  const [userData, setUserData] = useState<any[]>([]);

  useEffect(() => {
    (async () => {
      setCurrLoading(true);
      if (itemsData && itemsData.length > 0) {
        const newUserData = Object.entries(
          _.groupBy(itemsData, "user_index")
        ).map((userDataEntry) => {
          return {
            username: userDataEntry[1][0].username,
            userId: parseInt(userDataEntry[0], 10),
            items: userDataEntry[1],
            count: userDataEntry[1].reduce((prev, curr) => {
              return (prev += curr.quantity);
            }, 0),
          };
        });

        const itemsByLog = _.groupBy(itemsData, "log_index");

        const totaledItems = itemsData.reduce((acc, item) => {
          return (acc += item.quantity);
        }, 0);

        setUserData(newUserData);
        setTotalItems(totaledItems);
        setLogCount(Object.keys(itemsByLog).length);
        setCurrLoading(false);
      }
    })();
  }, [itemsData]);

  return {
    org,
    projects,
    itemsData,
    userData,
    logCount,
    totalItems,
    surveyResults,
    admins,
    loading:
      orgsLoading ||
      adminsLoading ||
      projectsLoading ||
      itemsLoading ||
      surveyLoading ||
      currLoading,
  };
};
